export type DownloadUrlItem = {
  url: string
  filename?: string
}

const DEFAULT_DELAY_MS = 400

const sleep = (ms: number) => new Promise<void>((resolve) => {
  setTimeout(resolve, ms)
})

const triggerDownload = (item: DownloadUrlItem) => {
  const link = document.createElement('a')
  link.href = item.url
  if (item.filename) {
    link.download = item.filename
  }
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  link.remove()
}

/**
 * Downloads files one by one with a delay so browsers do not block multiple downloads.
 */
export const downloadUrlsSequentially = async (
  items: DownloadUrlItem[],
  delayMs = DEFAULT_DELAY_MS,
): Promise<void> => {
  if (!items.length) {
    return
  }

  for (let i = 0; i < items.length; i++) {
    const item = items[i]
    if (!item?.url) {
      continue
    }

    triggerDownload(item)

    if (i < items.length - 1 && delayMs > 0) {
      await sleep(delayMs)
    }
  }
}
